module.exports = __webpack_public_path__ + "img/img8.016e0cd7.png";